// extracted by mini-css-extract-plugin
module.exports = {"container":"Partners-module--container--1jN4m","imgsRowWrapper":"Partners-module--imgsRowWrapper--10O2l"};